import { useSelector } from "react-redux";
import { selectAPIUnavailable, selectAuthAPIUnavailable } from "./APIStatusSlice";

export const APIStatusBanner: React.FC = () => {
  const apiUnavailable = useSelector(selectAPIUnavailable);
  const authAPIUnavailable = useSelector(selectAuthAPIUnavailable);

  if (!authAPIUnavailable && !apiUnavailable) return <></>;

  return (
    <div className="alert alert-dismissible bg-warning d-flex align-items-center px-4 px-sm-5 pt-sm-3 pb-4 pb-sm-3 mb-2 mt-4">
      <span className="fa fa-wifi-exclamation fa-xl text-dark me-4"></span>
      <div className="d-flex flex-column pe-10 text-dark">
        <h5 className="mb-1 text-dark">Could not reach your server</h5>
        <span>
          Please check your internet connection and{" "}
          <a href="" onClick={() => location.reload()} data-test-id="api-status-banner__refresh-page-link">
            refresh the page
          </a>
        </span>
      </div>

      <button
        type="button"
        className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
        data-bs-dismiss="alert"
        data-test-id="api-status-banner__close-button"
      >
        <span className="fa fa-times text-dark"></span>
      </button>
    </div>
  );
};
